import { useEffect, useState } from 'react';
import { useClient } from '@splitsoftware/splitio-react';

import { authStore } from '../../stores/authStore';
import { TreatmentTypes } from '../useSplitSdkConfig/constants';
import { useProfileInfoFetchQuery } from '../../queries/Profile';

export const useUserSplit = (splitName: string) => {
  const isAuthenticated = authStore.getState().authenticated;
  const [treatment, setTreatment] = useState(TreatmentTypes.CONTROL);

  const { data } = useProfileInfoFetchQuery(isAuthenticated);
  const { memberId } = data?.member || {};

  const client = useClient(memberId, 'user');

  useEffect(() => {
    client?.on(client.Event.SDK_READY, () => {
      setTreatment(client.getTreatment(splitName) as TreatmentTypes);
    });
  }, [client, splitName]);

  return { treatment };
};
